<template>
  <div>
    <app-home-detail v-bind:activeHomeDetail="activeHome" v-if="activeHome"
                     v-on:close-detail="activeHome = null"></app-home-detail>
    <div class="homes-list" v-bind:class="{'is-hidden': activeHome}">
      <div class="container">
        <app-home-filter v-if="homeSummaryList.length" v-bind:homeSummaryList="homeSummaryList" v-on:filteredHomes="filteredHomeList=$event"></app-home-filter>
        <div class="columns is-multiline is-variable is-6 boxes" id="masonry-boxes" v-if="filteredHomeList">
          <div class="column is-3-widescreen is-4-desktop is-6-tablet is-12-mobile"
               v-for="homeSummary in filteredHomeList">
            <app-home-card v-bind:homeSummary="JSON.parse(JSON.stringify(homeSummary))" v-on:homeSelected="activeHome = $event"></app-home-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import HomeCard from "@/components/journey/home/HomeCard";
import HomeDetail from "@/components/journey/home/HomeDetail";
import HomeFilter from "@/components/journey/home/HomeFilter";

export default {

  name: 'app-map',
  mixins: [],
  components: {
    'app-home-card': HomeCard,
    'app-home-detail': HomeDetail,
    'app-home-filter': HomeFilter
  },
  data() {
    return {
      activeHome: null,
      lotid: null,
      lotcpid: null,
      lotsummary: null,
      homeSummaryList: [],
      filteredHomeList: null,
      activeHomeDetail: null,
      locatedHnlSummary: null,
      sub: null
    }
  },
  watch: {
    activeHomeDetail: function (val, oldval) {
      this.$emit("setActiveHome", val)
    }
  },
  created() {
    this.lotid = this.$route.query.lotid;
    this.lotcpid = this.$route.query.lotcpid;
    this.initCompatibleHomeSummaryList(this.lotcpid);
  },
  destroyed() {
    this.sub();
  },
  methods: {
    selectHome: function (hnlSummary) {
      this.activeHome = hnlSummary;
    },

    nextPage: function (ev) {
      this.activeHomeDetail = ev;
      this.$emit('goNext', true);
    },

    initCompatibleHomeSummaryList: function (lotCpId) {
      if (lotCpId) {
        this.$store.dispatch('fetchCompatibleHomeSummaryList', {lotCpId, });
        this.sub = this.$store.subscribe((mutation, state) => {
          if (mutation.type === 'setCompatibleHomeSummaryList') {
            this.homeSummaryList = state.communityStore.homeSummary;
            this.filteredHomeList = this.homeSummaryList;
            this.$emit('homesLoaded', true);
          }
        });
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/home/CompatibleHomeList.vue